export default __webpack_public_path__ + "static/media/ic_remove.37998e40.svg";